import React from 'react';
import './molecules.css';

interface UnprovisionedScreenProps {
  onLogout: () => void;
}

export const UnprovisionedScreen: React.FC<UnprovisionedScreenProps> = ({
  onLogout,
}) => {
  return (
    <div className="min-h-screen relative overflow-hidden bg-[#E8A09A]">
      {/* Molecule clusters */}

      {/* Top right — Vertical pair */}
      <div className="mol" style={{position:'absolute',top:60,right:50,pointerEvents:'none'}}>
        <svg width="50" height="70" viewBox="0 -10 50 80" fill="none">
          <circle cx="25" cy="10" r="4" fill="#fff"/>
          <circle cx="25" cy="50" r="4" fill="#fff"/>
          <line x1="25" y1="10" x2="25" y2="50" stroke="#fff" strokeWidth="2"/>
          <path d="M29,7 Q39,-3 49,7 Q59,-3 69,7" fill="none" stroke="#1a1814" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      </div>

      {/* Bottom left — L-shape */}
      <div className="mol-d1" style={{position:'absolute',bottom:55,left:50,pointerEvents:'none'}}>
        <svg width="70" height="60" viewBox="-25 -5 95 65" fill="none">
          <circle cx="0" cy="0" r="4" fill="#fff"/>
          <circle cx="0" cy="35" r="5" fill="#fff"/>
          <circle cx="40" cy="35" r="4" fill="#fff"/>
          <line x1="0" y1="0" x2="0" y2="35" stroke="#fff" strokeWidth="2"/>
          <line x1="0" y1="35" x2="40" y2="35" stroke="#fff" strokeWidth="2"/>
          <path d="M-4,0 Q-14,-10 -24,0" fill="none" stroke="#1a1814" strokeWidth="3" strokeLinecap="round"/>
          <path d="M0,40 Q-10,50 0,55" fill="none" stroke="#1a1814" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-7 text-center">
        {/* Lock icon */}
        <div className="w-[72px] h-[72px] bg-white/30 rounded-[20px] flex items-center justify-center mb-6">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
            <rect x="5" y="11" width="14" height="10" rx="2" stroke="#1A1814" strokeWidth="1.5"/>
            <path d="M8 11V7a4 4 0 118 0v4" stroke="#1A1814" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </div>

        <h1 className="text-[#1A1814] text-[28px] font-semibold leading-tight">
          Account not activated
        </h1>

        <p className="text-[#1A1814]/60 text-[15px] mt-3.5 leading-relaxed max-w-[300px]">
          Your account needs to be activated by a researcher before you can participate.
          Please contact your research coordinator.
        </p>

        <button
          onClick={onLogout}
          className="mt-8 bg-[#1A1814] text-white rounded-[28px] py-[16px] px-10 text-[15px] font-semibold tracking-[1px]"
        >
          SIGN OUT
        </button>
      </div>
    </div>
  );
};

export default UnprovisionedScreen;
